import DataGridTableSkeleton from "../../../components/skeletons/DataGridTableSkeleton";

export default function WorkOrdersListSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
